import { text } from './text';

/**
 * extend the textarea observable
 * @param {Observable} local - observable define for property
 * @param {Object} attrs - property define
 * @param {FieldOption} fieldOption - field of property
 * @param {Object} viewModel - model value of entity
 * @returns {undefined} - the function extend passed local directly
 */
export function textarea(local, attrs, fieldOption, viewModel) {
  // Currently the same with text
  text(local, attrs, fieldOption, viewModel);
}
